exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social[data-v-7d6c642e]{margin-top:20px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.social_small-text[data-v-7d6c642e]{font-size:14px}.social__note[data-v-7d6c642e]{margin-right:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d6c642e","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/share/Social.vue
// module id = 32f5493812dddb0943b7
// module chunks = 0